// extracted by mini-css-extract-plugin
export default {"imageStyle":"mCtkQm"};